export default __webpack_public_path__ + "ee0c5624c1aae4daa235d7f3fd542f2a.svg";